import { Card, CardContent, Typography, Box } from "@mui/material";

export default function StepCard({ number, icon, title, description }) {
  return (
    <Card
      sx={{
        height: "100%",
        bgcolor: "rgba(13, 16, 22, 0.65)",
        border: "1px solid rgba(255, 255, 255, 0.07)",
        borderRadius: "16px",
        backdropFilter: "blur(14px)",
        position: "relative",
        overflow: "hidden",
        p: { xs: 2.5, md: 3 },
        transition: "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
        "&:hover": {
          borderColor: "rgba(0, 173, 181, 0.35)",
          boxShadow: "0 20px 40px -15px rgba(0,0,0,0.8), 0 0 30px -5px rgba(0, 173, 181, 0.15)",
          transform: "translateY(-3px)",
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Box
          sx={{
            width: 46,
            height: 46,
            borderRadius: "12px",
            bgcolor: "rgba(0, 173, 181, 0.1)",
            border: "1px solid rgba(0, 173, 181, 0.25)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#00ADB5",
          }}
        >
          {icon}
        </Box>

        <Typography
          sx={{
            fontFamily: "ui-monospace, monospace",
            fontSize: "1.4rem",
            fontWeight: 800,
            color: "rgba(255, 255, 255, 0.15)",
          }}
        >
          0{number}
        </Typography>
      </Box>

      <Typography
        variant="h5"
        sx={{
          color: "#ffffff",
          fontWeight: 700,
          fontSize: "1.2rem",
          letterSpacing: "-0.01em",
          mb: 1.5,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          color: "#94a3b8",
          fontSize: "0.92rem",
          lineHeight: 1.65,
        }}
      >
        {description}
      </Typography>
    </Card>
  );
}
